import { MenuButton } from '@chakra-ui/react';

export const DropdownButton = (props) => (
  <MenuButton
    type="button"
    _active={{ color: 'primary.500' }}
    fontWeight="medium"
    {...props}
  />
);
